import type IntentSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/intent/IntentSignalFilters";
import type { ICountryObject } from "app/services/CountryService";
import { getOptionsFromArray } from "app/pages/sales-intelligence/sub-modules/signals/utils/filterValue";

type FilterStateParams = {
    filters: Partial<IntentSignalFilters>;
    countries: readonly ICountryObject[];
};

export const initialiseFiltersState = ({
    filters,
    countries,
}: FilterStateParams): (() => Partial<IntentSignalFilters>) => {
    return () => ({
        ...filters,
        countries: getOptionsFromArray(filters.countries, countries),
    });
};
